import { fetchAndActivate, getBoolean, getValue } from 'firebase/remote-config';
import { remoteConfig } from '@/main.js'; // Import the firebaseApp from main.js

/**
 * Custom hook to interact with Firebase Remote Config.
 * This hook provides a method to fetch and return boolean flags from Firebase Remote Config.
 * If the flag is not found or an error occurs, it returns a default value.
 *
 */
export default function useFirebase() {
  async function getBooleanFlag(flagName: string, defaultValue: boolean = false): Promise<boolean> {
    if (!remoteConfig) {
      return defaultValue;
    }

    try {
      await fetchAndActivate(remoteConfig);
      return getBoolean(remoteConfig, flagName);
    } catch (err) {
      console.error(`Error getting boolean flag '${flagName}':`, err);
      return defaultValue;
    }
  }

  async function getStringFlag(flagName: string, defaultValue: string = ''): Promise<string> {
    if (!remoteConfig) {
      return defaultValue;
    }

    try {
      await fetchAndActivate(remoteConfig);
      const value = getValue(remoteConfig, flagName);
      return value.asString();
    } catch (err) {
      console.error(`Error getting string flag '${flagName}':`, err);
      return defaultValue;
    }
  }

  return {
    getBooleanFlag,
    getStringFlag,
  };
}
